import {FullCard} from '../Components/Sections/tilt-card.component';
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router';
import {Slots} from '../slots';
import {AccessBtnComponent} from '../Components/access-btn.component';
import Modal from 'react-modal';
import NotFoundPage from './NotFoundPage';
import {Helmet} from '@dr.pogodin/react-helmet';

const SlotPage: React.FC = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [slot, setSlot] = React.useState<any>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    useEffect(() => {
        const game = Slots.find(slot => slot.id === id);
        if (!game) {
            return;
        }

        setSlot(game);

        return () => {
            document.body.style.overflowY = 'auto'; // Cleanup on unmount
        }
    }, [id]);


    const openModal = (image: string) => {
        document.body.style.overflowY = 'hidden';
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        document.body.style.overflowY = 'auto';
        setSelectedImage(null);
        setIsModalOpen(false);
    };

    if (!slot) {
        return <NotFoundPage/>;
    }


    return (
        <>
            <Helmet>
                <title>{slot?.title} - Lesia K Slot 2D Art Development</title>
                <link rel="canonical" href={`https://lesia-k.com/slot/${slot.id}`}/>
                <meta name="description"
                      content={slot?.descriptionTxt?.innerText}/>
                <meta name="keywords" content={`slot, art, 2D art slot, ${slot?.title?.split(' ').join(', ')}`}/>
                <meta property="og:title" content={`${slot?.title} - Lesia K Slot 2D Art Development`}/>
                <meta property="og:description"
                      content={slot?.descriptionTxt?.innerText}/>
                <meta property="og:image" content={slot?.images[0] || 'https://lesia-k.com/assets/Pictures/Fish.png'}/>
                <meta property="og:url" content={`https://lesia-k.com/slot/${slot?.id}`}/>
                <meta name="twitter:title" content={`${slot?.title} - Lesia K Slot 2D Art Development`}/>
                <meta name="twitter:description"
                      content={slot?.descriptionTxt?.innerText}/>
            </Helmet>
            <section className="min-h-screen w-screen overflow-hidden md:p-5 p-0">

                <div className="p-10 mx-auto grid grid-cols-1 gap-8 relative">
                    <FullCard feature={{
                        title: slot?.title,
                        description: null as any,
                        image: slot?.characterImage
                    }} index={1} showImage/>
                </div>
                {slot?.description && (
                    <div className="m-auto text-2xl font-inter text-pink-200 text-center ">
                        {slot?.description}
                    </div>
                )}
                <div className="w-full m-auto">
                    <h2 className={"md:text-7xl text-center text-gray-400 text-3xl font-boldonse p-5"}>Game Assets</h2>
                    {slot?.images.map((image: string, index: number) => (
                        <img
                            className="max-h-screen py-5 hover:scale-105 m-auto"
                            src={image}
                            key={index}
                            alt={slot?.title + index}
                            onClick={() => openModal(image)}
                        />))}
                </div>
                {slot && slot?.descriptionTxt && (
                    <div className="m-auto text-2xl font-inter text-pink-200 text-center p-10 max-w-4xl">
                        {slot?.descriptionTxt}
                    </div>)}


                <div className="flex md:flex-row flex-col w-full justify-center items-center gap-8">
                    <AccessBtnComponent text="See more slots"
                                        onClick={() => navigate('/slots')}
                                        className="px-24 py-8 border-2 border-pink-700 rounded-xl text-white relative mt-6 text-lg bg-pink-600 font-semibold"/>
                </div>
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    contentLabel="Image Modal"
                    className="flex justify-center items-center bg-black bg-opacity-50 fixed inset-0 z-10"
                    overlayClassName="fixed inset-0 bg-black bg-opacity-75"
                >
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="Fullscreen Symbol"
                            className="max-w-full max-h-full object-contain"
                            onClick={closeModal}
                        />
                    )}
                    <button
                        onClick={closeModal}
                        className="md:p-10 p-5 absolute top-20 right-4 text-white text-4xl"
                    >
                        &times;
                    </button>
                </Modal>

            </section>
        </>
    );
}

export default SlotPage;
